module.exports = __webpack_public_path__ + "static/img/y-2.9bee55cc.png";